import { useEffect, useState } from 'react';
import { adminApi } from '@formosa/shared/api/admin';
import {
  ACCESS_TYPE_OPTIONS,
  EMPTY_PACK_FORM,
  PACK_STATUS_FORM_OPTIONS,
} from './reactionConstants';

export default function ReactionPackEditModal({ open, packId, onClose, onSaved }) {
  const isEdit = packId != null;
  const [form, setForm] = useState(EMPTY_PACK_FORM);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!open) return;
    setError('');
    if (!isEdit) {
      setForm({ ...EMPTY_PACK_FORM });
      return;
    }
    setBusy(true);
    adminApi
      .getImReactionPack(packId)
      .then((data) =>
        setForm({
          ...EMPTY_PACK_FORM,
          ...data,
          coverEmoji: data?.coverEmoji || '',
          subscriptionRequirement: data?.subscriptionRequirement || '',
        })
      )
      .catch((e) => setError(e.message || '載入失敗'))
      .finally(() => setBusy(false));
  }, [open, packId, isEdit]);

  if (!open) return null;

  async function handleSubmit(e) {
    e.preventDefault();
    setBusy(true);
    setError('');
    try {
      if (isEdit) await adminApi.updateImReactionPack(packId, form);
      else await adminApi.createImReactionPack(form);
      onSaved?.(isEdit);
      onClose?.();
    } catch (err) {
      setError(err.message || '儲存失敗');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="modal-backdrop">
      <div className="modal-card">
        <h3>{isEdit ? '編輯回覆表情包' : '新增回覆表情包'}</h3>
        <form onSubmit={handleSubmit} className="form-grid">
          <label>
            名稱
            <input
              required
              value={form.name}
              onChange={(e) => setForm((p) => ({ ...p, name: e.target.value }))}
            />
          </label>
          <label>
            Tab 圖示 emoji
            <input
              value={form.coverEmoji}
              onChange={(e) => setForm((p) => ({ ...p, coverEmoji: e.target.value }))}
            />
          </label>
          <label>
            Access
            <select
              value={form.accessType}
              onChange={(e) => setForm((p) => ({ ...p, accessType: e.target.value }))}
            >
              {ACCESS_TYPE_OPTIONS.map((o) => (
                <option key={o.value} value={o.value}>
                  {o.label}
                </option>
              ))}
            </select>
          </label>
          <label>
            訂閱要求
            <input
              value={form.subscriptionRequirement}
              onChange={(e) =>
                setForm((p) => ({ ...p, subscriptionRequirement: e.target.value }))
              }
              placeholder="如 VIP"
            />
          </label>
          <label>
            狀態
            <select
              value={form.status}
              onChange={(e) => setForm((p) => ({ ...p, status: e.target.value }))}
            >
              {PACK_STATUS_FORM_OPTIONS.map((o) => (
                <option key={o.value} value={o.value}>
                  {o.label}
                </option>
              ))}
            </select>
          </label>
          <label>
            分類
            <input
              value={form.category}
              onChange={(e) => setForm((p) => ({ ...p, category: e.target.value }))}
              placeholder="DEFAULT / POPULAR / QUICK"
            />
          </label>
          <label>
            排序
            <input
              type="number"
              value={form.sort}
              onChange={(e) => setForm((p) => ({ ...p, sort: Number(e.target.value) || 0 }))}
            />
          </label>
          <label className="form-grid__full">
            描述
            <textarea
              value={form.description}
              onChange={(e) => setForm((p) => ({ ...p, description: e.target.value }))}
              rows={2}
            />
          </label>
          {error ? <p className="form-error">{error}</p> : null}
          <div className="modal-actions">
            <button type="button" className="btn btn-secondary" onClick={onClose} disabled={busy}>
              取消
            </button>
            <button type="submit" className="btn btn-primary" disabled={busy}>
              儲存
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
